import React from 'react'
import { GuardProvider } from 'react-router-guards'
import { RouteFactory } from './route-factory'

// Layouts base
import { BaseLayout, LoginLayout } from '../layouts'

// Pages
import HomeFactory from '../../../main/factories/home/home-factory'
import PageNotFound from '../../pages/page-not-found'

const Routes = ():JSX.Element => {
  const routes = [
    {
      layout: LoginLayout,
      pages: [
        // TO DO
      ],
    },
    {
      layout: BaseLayout,
      pages: [
        { path: '/', component: HomeFactory },
        { path: '*', component: PageNotFound },
      ],
    },
  ]

  return (
    <GuardProvider>
      <RouteFactory routes={routes} />
    </GuardProvider>
  )
}

export default Routes
